import { Button } from "@material-tailwind/react";
import React, {useEffect, useState} from "react";

import "./StateHandler.css";
import {HttpStatusCode} from "axios";


interface stateHandlerLinkProps {link: string, label:string}

interface StateHandlerProps {
    title: string;
    subTitle: string;
    links?: stateHandlerLinkProps[];
    reload?: boolean;
    showFcitecLink?: boolean;
    showLinks?: boolean;
    statusCode?: number;
}

const StateHandler = ({
    title,
    subTitle = "",
    links = [],
    reload = false,
    showFcitecLink = true,
    showLinks = true,
    statusCode = 0
}: StateHandlerProps) => {
    const  [isAdmin, setIsAdmin] = useState(false);
    
    const reloadPage = () => {
        window.location.reload();
    };

    const getLinksButtons = (prop: stateHandlerLinkProps[]) => {

        let linksBtProp = prop;

        if (showFcitecLink) {
            linksBtProp = [ {link: "/", label: "Ir a FCITEC"} as stateHandlerLinkProps, ...links];
        }

        return linksBtProp.map(({link, label}, index) => (
            <div key={index} className="link-btn">
                <a href={link}>
                    <Button placeholder={""} children={label} />
                </a>
            </div>
        ));
    }

    useEffect(() => {
        if (window.location.pathname.includes('admin')) {
            setIsAdmin(true);
        } else {
            setIsAdmin(false);
        }
    }, []);

    return (
        <div className="state-handler">
            <div className="state-handler__content">
                <h2 className="state-handler__title">{title}</h2>
                <p className="state-handler__sub-title">{subTitle}</p>
                <div className="state-handler__links">
                    { ((showLinks && !isAdmin) || (statusCode === HttpStatusCode.Unauthorized)) && getLinksButtons(links) }
                </div>
                <div className="state-handler__links">
                    {(reload || isAdmin) && (
                        <Button placeholder={""} children={"Recargar"} onClick={reloadPage}/>
                    )}
                </div>
            </div>
        </div>
        );
    }

export default StateHandler;